const OzLivenessGesture = [
  "video_selfie_smile",
  "video_selfie_eyes",
  "video_selfie_scan",
  // "video_selfie_left",
  // "video_selfie_right",
  // "video_selfie_down",
  // "video_selfie_high",
];

export const randomGesture = () => {
  return OzLivenessGesture[
    Math.floor(Math.random() * OzLivenessGesture.length)
  ];
};
